import { Notifications } from '@mui/icons-material';
import {
    Badge,
    ListItemButton,
    ListItemIcon,
    ListItemText
} from '@mui/material';
import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/material/styles';
import React from 'react';
import { useDispatch, useSelector } from '../../redux/hooks';
import {
    selectNotificationsCount,
    fetchNotificationsCount
} from '../../redux/actions/notifications';
import { COLOR_NAV_HOVER } from '../../theme';

type PropsType = {
    sx?: SxProps<Theme>,
    backgroundColor: string,
    textColor: string,
    active?: boolean,
    onClick: () => void
};

const FETCH_INTERVAL = 1 * 60 * 1000;

export default function NotificationsMenuItem({
    sx,
    backgroundColor,
    textColor,
    active = false,
    onClick
}: PropsType) {
    const dispatch = useDispatch();
    const notificationsCount = useSelector(selectNotificationsCount());

    React.useEffect(() => {
        dispatch(fetchNotificationsCount());
        const intervalId = window.setInterval(() => {
            dispatch(fetchNotificationsCount());
        }, FETCH_INTERVAL);
        return () => window.clearInterval(intervalId);
    }, [dispatch]);

    return (
        <ListItemButton
            key="notifications"
            onClick={onClick}
            sx={{
                ...sx,
                background: backgroundColor,
                '&:hover': {
                    background: active ? backgroundColor : COLOR_NAV_HOVER
                }
            }}
        >
            <ListItemIcon sx={{ color: textColor }}>
                <Badge
                    badgeContent={notificationsCount}
                    color="error"
                >
                    <Notifications />
                </Badge>
            </ListItemIcon>
            <ListItemText primary="Händelser" sx={{ color: textColor }} />
        </ListItemButton>
    );
}
